import { Flex, Grid, Skeleton } from "@chakra-ui/react"

const CompaniesListSkeleton = ({ isLoaded = true }) => {
  return (
    <>
      <Grid
        templateColumns={{ base: "1fr", md: "2fr 1fr" }}
        columnGap="24px"
        rowGap="12px"
        mb="24px"
      >
        <Skeleton
          {...{ isLoaded }}
          w="100%"
          bg="#7E869E11"
          borderRadius="6px"
          px="20px"
          py="8px"
        >
          <Flex alignItems="center" columnGap="24px">
            <Skeleton
              borderRadius="4px"
              w="100%"
              maxW="60px"
              h="24px"
            />
            <Skeleton
              borderRadius="4px"
              w="100%"
              maxW="300px"
              h="32px"
            />
            <Flex alignItems="center" columnGap="12px" w="100%">
              <Skeleton
                borderRadius="4px"
                w="100%"
                maxW="80px"
                h="32px"
              />
              <Skeleton
                borderRadius="4px"
                w="100%"
                maxW="80px"
                h="32px"
              />
              <Skeleton
                borderRadius="4px"
                w="100%"
                maxW="80px"
                h="32px"
              />
            </Flex>
          </Flex>
        </Skeleton>
        <Skeleton
          {...{ isLoaded }}
          w="100%"
          bg="#7E869E11"
          borderRadius="6px"
          px="20px"
          py="8px"
        >
          <Flex alignItems="center" columnGap="24px">
            <Skeleton
              borderRadius="4px"
              w="100%"
              maxW="60px"
              h="24px"
            />
            <Skeleton
              borderRadius="4px"
              w="100%"
              maxW="300px"
              h="32px"
            />
          </Flex>
        </Skeleton>
      </Grid>
      <Flex w="100%" direction="column" rowGap="1px">
        {Array.from(Array(25).keys())?.map((sk) => (
          <Skeleton
            key={sk}
            {...{ isLoaded }}
            w="100%"
            bg="#7E869E11"
            borderRadius="6px"
            px="20px"
            py="8px"
          >
            <Flex alignItems="center" h="32px" columnGap="1px">
              {Array.from(Array(6).keys())?.map((skt, idx) => (
                <Skeleton
                  w="100%"
                  minW={idx === 0 ? "320px" : undefined}
                  h="32px"
                  key={skt}
                  borderRadius="2px"
                  px="20px"
                />
              ))}
            </Flex>
          </Skeleton>
        ))}
      </Flex>
      <Flex align="center" justifyContent="end" w="100%">
        <Flex w="360px">
          <Skeleton
            w="100%"
            {...{ isLoaded }}
            bg="#7E869E11"
            borderRadius="6px"
            px="20px"
            py="8px"
          >
            <Flex alignItems="center" w="100%" columnGap="24px">
              <Skeleton
                borderRadius="4px"
                w="100%"
                maxW="60px"
                h="24px"
              />
              <Skeleton
                borderRadius="4px"
                w="100%"
                maxW="40px"
                h="24px"
              />
              <Skeleton
                borderRadius="4px"
                w="100%"
                maxW="80px"
                h="24px"
              />
              <Flex align="center" w="100%" columnGap="12px">
                <Skeleton
                  borderRadius="4px"
                  w="100%"
                  maxW="24px"
                  h="24px"
                />
                <Skeleton
                  borderRadius="4px"
                  w="100%"
                  maxW="24px"
                  h="24px"
                />
              </Flex>
            </Flex>
          </Skeleton>
        </Flex>
      </Flex>
    </>
  )
}

export default CompaniesListSkeleton
